import pdfjs from "@bundled-es-modules/pdfjs-dist/build/pdf";
import viewer from "@bundled-es-modules/pdfjs-dist/web/pdf_viewer";
import preprocessImage from "./image_preprocessing";

const md5 = require("./vendor/md5.min.js");

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// ************************ Drag and drop ***************** //
function DragAndDrop(selector, options) {
  if (options === undefined) options = {};
  this.selector = selector;
  this.uploadProgress = [];
  this.progressBar = $(selector).find(".progress-bar");
  this.files = [];
  this.newFiles = [];
  this.removedFiles = [];
  this.promises = [];
  this.multiple = options.multiple || false;
  this.uploadUrl = options.uploadUrl || "/upload";
  this.syncSubmission = options.syncSubmission || false;
  this.submissionData = { submitted: false };
}

DragAndDrop.prototype.initialize = function() {
  const prototype = this;

  // **** Hacky FormData polyfill *** //
  prototype.formData = {};
  prototype.formData.append = function(property, value) {
    if (value instanceof File || value instanceof Blob) {
      // if the value is a file, we need to append to the array of files.
      // this mimics what a real FormData object would do.
      if (!this.hasOwnProperty(property)) {
        // create default array if not present at the property.
        this[property] = [];
      }
      const files = this[property];
      files.push(value);
    } else {
      this[property] = value;
    }
  };
  prototype.formData.delete = function(name) {
    delete this[String(name)];
  };
  prototype.formData.getAll = function(name) {
    return this[String(name)] || [];
  };
  // **** End Hacky FormData polyfill *** //

  prototype.files = [];
  prototype.newFiles = [];
  prototype.removedFiles = [];
  prototype.promises = [];

  $(prototype.selector)
    .find(".drop-file img, .drop-file canvas")
    .each(function() {
      const blob = new Blob([""], { type: "" });
      blob.lastModifiedDate = new Date();
      blob.name = $(this).attr("data-file-name");
      blob.id = $(this).attr("data-file-id");
      blob.checksum = $(this).attr("data-file-checksum");
      blob.existing = true;
      prototype.files.push(blob);
    });
};

// ************************ Bind events ***************** //
DragAndDrop.prototype.bindEvents = function() {
  const prototype = this;
  // Highlight drop area when item is dragged over it
  prototype.bindDragEvents();
  // Handle dropped files
  prototype.bindDropEvents();

  prototype.bindEvent("change", ".drop-file-input", function(event) {
    prototype.handleFiles(this.files);
  });

  prototype.bindEvent("click", ".drop-file-delete-temp", function(event) {
    event.preventDefault();
    prototype.clearFile(this);
  });

  if (prototype.syncSubmission) {
    // Why do this if we do it in handle files?
    // prototype.bindSubmissionEvent();
  }
};

DragAndDrop.prototype.bindDragEvents = function() {
  const prototype = this;
  const events = "dragenter dragover";

  $(document).off(events, prototype.selector);
  $(document).on(events, prototype.selector, function(event) {
    event.preventDefault();
    event.stopPropagation();
    prototype.highlight();
  });
};

DragAndDrop.prototype.bindDropEvents = function() {
  const prototype = this;
  const events = "dragleave drop";

  $(document).off(events, prototype.selector);
  $(document).off("drop", prototype.selector);
  $(document).on(events, prototype.selector, function(event) {
    event.preventDefault();
    event.stopPropagation();
    prototype.unhighlight();
  });
  $(document).on("drop", prototype.selector, function(event) {
    event.preventDefault();
    event.stopPropagation();
    prototype.handleDrop(event);
  });
};

DragAndDrop.prototype.bindEvent = function(event, selector, func) {
  if (selector === undefined || selector === "") {
    selector = this.selector;
  } else {
    selector = `${this.selector} ${selector}`;
  }

  // prevent rebinding multiple times
  $(document).off(event, selector);
  $(document).on(event, selector, func);
};

DragAndDrop.prototype.bindSubmissionEvent = function() {
  const prototype = this;
  const form = $(prototype.selector).parents("form");
  if (form[0] === undefined) {
    return false;
  }
  const form_id = form[0].id;
  $(document).off("submit", `#${form_id}`);
  $(document).on("submit", `#${form_id}`, function(event) {
    prototype.resetFileField();
    const form = $(this);

    if (!prototype.submissionData.submitted) {
      event.preventDefault();

      new Promise(function(resolve, reject) {
        let { formData } = prototype;
        let method;
        const _method = form.find("input").filter(function() {
          return this.name === "_method";
        })[0];
        method = _method ? $(_method).val() : form.attr("method");
        formData = prototype._prepareFormData(formData);

        const input = $(prototype.selector).find(".drop-file-input")[0];
        const name = input.id.split("_")[input.id.split("_").length - 1];
        const hiddenInput = $(`#${input.id.replace(name, "id")}`)[0];
        if (name && hiddenInput) {
          formData.append(hiddenInput.name, $(hiddenInput).val());
        }

        let action = form.attr("action");
        // If we need the form to have a different action for the file uploads.
        const fileAction = form.attr("data-file-action");
        if (fileAction) {
          action = fileAction;
        }

        $.ajax({
          type: method,
          url: action,
          processData: false,
          contentType: false,
          data: formData,
          success(data) {
            if (data.status === "error") {
              prototype.submissionData.submitted = false;
              reject(data);
            } else {
              prototype.submissionData.submitted = true;
              resolve(data);
            }
          }
        });
      }).then(function() {
        form.submit();
      });
    }
  });
};

// ************************ File handling ***************** //
DragAndDrop.prototype.handleDrop = function(event) {
  const dt = event.originalEvent.dataTransfer;
  if (dt === undefined || ($(this.selector).hasClass("open") && !this.multiple))
    return false;
  let { files } = dt;

  files = this.filterAcceptableFiles(files);
  this.handleFiles(files);
};

DragAndDrop.prototype.filterAcceptableFiles = function(files) {
  const prototype = this;
  const accepts = $(prototype.selector)
    .find(".drop-file-input")
    .attr("accept")
    .split(",")
    .join("|");
  files = [...files];
  return files.filter(function(file) {
    return file.type.match(accepts);
  });
};

DragAndDrop.prototype.handleFiles = function(files) {
  const prototype = this;
  prototype.mergeFiles(files).then(function() {
    prototype.resetFileField();
    prototype.promises = [];

    const newFiles = prototype.newFiles.filter(function(file) {
      return !file.existing;
    });
    const existingFiles = prototype.newFiles.filter(function(file) {
      return file.existing;
    });

    if (existingFiles.length > 0) {
      prototype._handleExistingFiles(existingFiles);
    }

    if (newFiles.length > 0) {
      prototype._handleNewFiles(newFiles);

      if (prototype.syncSubmission) {
        prototype.bindSubmissionEvent();
      }
    }
  });
};

DragAndDrop.prototype.mergeFiles = function(files) {
  const prototype = this;

  return new Promise(function(resolve, reject) {
    const fileFieldName = $(prototype.selector)
      .find(".drop-file-input")
      .attr("name");
    prototype.newFiles = [];
    prototype.promises = [];

    if (prototype.files.length === 0) {
      prototype._addDataToFiles(files, { new: true });

      Promise.all(prototype.promises).then(function(files) {
        files.forEach(function(file) {
          prototype.formData.append(fileFieldName, file);
          prototype.newFiles.push(file);
          prototype.files.push(file);
        });

        resolve("merged files");
      });
    } else {
      prototype._addDataToFiles(files, { new: false });

      Promise.all(prototype.promises).then(function(files) {
        files.forEach(function(file) {
          const fileExists = prototype.files.some(function(f) {
            return f.checksum === file.checksum;
          });
          const removedFile = prototype.removedFiles.filter(function(f) {
            return f.checksum === file.checksum;
          })[0];

          if (fileExists) {
            // do nothing
          } else if (removedFile) {
            prototype.newFiles.push(removedFile);
            prototype.files.push(removedFile);
          } else {
            const lastFile = prototype.getUploadedFiles()[
              prototype.getUploadedFiles().length - 1
            ] || { id: "new_0" };
            const lastId = parseInt(lastFile.id.replace("new_", ""));
            file.id = `new_${lastId + 1}`;
            file.existing = false;
            prototype.formData.append(fileFieldName, file);
            prototype.newFiles.push(file);
            prototype.files.push(file);
          }
        });

        resolve("merged files");
      });
    }
  });
};

DragAndDrop.prototype._calculateChecksum = function(file) {
  const checksum_reader = new FileReader();
  const promise = new Promise(function(resolve, reject) {
    checksum_reader.onloadend = function(event) {
      this.checksum = md5.base64(event.target.result);
      resolve(this);
    }.bind(file);
  });
  checksum_reader.readAsArrayBuffer(file);
  return promise;
};

DragAndDrop.prototype._handleExistingFiles = function(files) {
  const prototype = this;
  files = [...files];
  prototype.initializeProgress(files.length);
  files.forEach(prototype.repreviewFile.bind(prototype));
  files.forEach(prototype.unclearFile.bind(prototype));
};

DragAndDrop.prototype._handleNewFiles = function(files) {
  const prototype = this;
  $(prototype.selector)
    .find(".progress")
    .removeClass("invisible");
  // cast into Array
  files = [...files];
  prototype.initializeProgress(files.length);
  files.forEach(prototype.uploadFile.bind(prototype));
  files.forEach(prototype.previewFile.bind(prototype));
};

DragAndDrop.prototype._addDataToFiles = function(files, options) {
  const prototype = this;
  files = [...files];
  files.forEach(function(file, index) {
    prototype.promises.push(prototype._calculateChecksum(file));
    if (options.new) {
      file.id = `new_${index + 1}`;
      file.existing = false;
    }
  });
  return files;
};

// ************************ Uploading ***************** //
DragAndDrop.prototype.initializeProgress = function(numFiles) {
  this.progressBar = $(this.selector).find(".progress-bar");
  this.progressBar.width(`${0}%`);
  this.uploadProgress = [];

  for (let i = numFiles; i > 0; i--) {
    this.uploadProgress.push(0);
  }
};

DragAndDrop.prototype.updateProgress = function(fileNumber, percent) {
  this.uploadProgress[fileNumber] = percent;
  const total =
    this.uploadProgress.reduce(function(tot, curr) {
      return tot + curr;
    }, 0) / this.uploadProgress.length;
  this.progressBar.width(`${total}%`);

  if (total === 100) {
    $(this.selector)
      .find(".progress")
      .addClass("invisible");
  }
};

DragAndDrop.prototype.uploadFile = function(file, i) {
  const prototype = this;
  const url = prototype.uploadUrl;
  const xhr = new XMLHttpRequest();
  let formData = new FormData();

  xhr.open("POST", url, true);
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

  // Update progress (can be used to show progress indicator)
  xhr.upload.addEventListener("progress", function(event) {
    prototype.updateProgress(i, (event.loaded * 100.0) / event.total || 100);
  });

  xhr.addEventListener("readystatechange", function(event) {
    if (xhr.readyState === 4 && xhr.status === 200) {
      prototype.updateProgress(i, 100); // <- Add this
    } else if (xhr.readyState === 4 && xhr.status !== 200) {
      // Error. Inform the user
    }
  });

  formData = this._prepareFormData(formData);
  formData.append("file", file);
  xhr.send(formData);
};

// ************************ File DOM interactions ***************** //
DragAndDrop.prototype.previewFile = async function(file) {
  const reader = new FileReader();
  const prototype = this;

  const promise = new Promise(function(resolve, reject) {
    reader.onloadend = function(event) {
      let element;

      if (this.type === "application/pdf") {
        element = document.createElement("canvas");
        (async () => {
          // slice the dataUrl into a base64 string for IE11 reasons.
          // unfortunately stream reading off of a dataUrl is broken in IE11.
          // we will convert the base64 string pdf into a uint8Array instead.
          const base64PdfString = event.target.result.slice(28);
          const raw = atob(base64PdfString);
          const uint8Array = new Uint8Array(raw.length);
          for (let i = 0; i < raw.length; i++) {
            uint8Array[i] = raw.charCodeAt(i);
          }
          const loadingTask = pdfjs.getDocument(uint8Array);
          const pdf = await loadingTask.promise;

          // Load information from the first page.
          const page = await pdf.getPage(1);
          let viewport = page.getViewport(1);
          const { width, height } = viewport;
          const indexSize = 256;

          let canvasWidth = width;
          let canvasHeight = height;

          if (width > indexSize || height > indexSize) {
            let scale = 1;
            canvasWidth = indexSize;
            canvasHeight = indexSize;
            if (height > width) {
              scale = canvasWidth / width;
              canvasHeight = height * scale;
            }
            if (width > height) {
              scale = canvasHeight / height;
              canvasWidth = width * scale;
            }
            viewport = page.getViewport(scale);
          }

          // Apply page dimensions to the <canvas> element.
          const canvas = element;
          canvas.height = canvasHeight;
          canvas.width = canvasWidth;

          const context = canvas.getContext("2d");

          // Render the page into the <canvas> element.
          const renderContext = {
            canvasContext: context,
            viewport
          };
          await page.render(renderContext);
        })();
      } else {
        element = document.createElement("img");
      }

      element.src = event.target.result;
      element.setAttribute("data-file-id", this.id);
      element.setAttribute("data-file-checksum", this.checksum);
      const html =
        '<div class="drop-file"><a class="text-danger drop-file-delete drop-file-delete-temp">' +
        '<i class="fa fa-times"</a></div>';
      prototype._setBaseHTML(html);
      $(prototype.selector)
        .find(".drop-file")
        .last()
        .append(element);
      resolve(this);
    }.bind(file);
  });
  const processedImage = await preprocessImage(file);
  reader.readAsDataURL(processedImage);
  prototype.promises.push(promise);
};

DragAndDrop.prototype.repreviewFile = function(file) {
  const prototype = this;
  if (!file.html) {
    return false;
  }
  const promise = new Promise(function(resolve, reject) {
    prototype._setBaseHTML(file.html);
    resolve(this);
  });
  prototype.promises.push(promise);
};

DragAndDrop.prototype.clearFiles = function() {
  const prototype = this;
  prototype.resetFileField();
  $(prototype.selector)
    .find(".drop-file")
    .remove();
  $(prototype.selector)
    .find(".drop-clear-files-button")
    .addClass("invisible");
};

DragAndDrop.prototype.clearFile = function(element) {
  const prototype = this;
  const fileId = $(element)
    .siblings("img,iframe,canvas")
    .first()
    .attr("data-file-id");
  const fileChecksum = $(element)
    .siblings("img,iframe,canvas")
    .first()
    .attr("data-file-checksum");

  // Check if new file
  if (fileId.indexOf("new_") !== -1) {
    prototype.getUploadedFiles().some(function(file, index) {
      if (file.checksum === fileChecksum) {
        const fileFieldName = $(prototype.selector)
          .find(".drop-file-input")
          .attr("name");
        const newFiles = prototype.getUploadedFiles();
        newFiles.splice(index, 1);
        prototype.formData.delete(fileFieldName);
        newFiles.forEach(function(newFile) {
          prototype.formData.append(fileFieldName, newFile);
        });
        return true;
      }
    });
  }

  prototype.files.some(function(file, index) {
    if (file.checksum === fileChecksum) {
      file.html = $(element).parents(".drop-file")[0].outerHTML;
      prototype.removedFiles.push(file);
      prototype.files.splice(index, 1);
      return true;
    }
  });

  $(element)
    .parents(".drop-file")
    .remove();
};

DragAndDrop.prototype.unclearFile = function(file) {
  const prototype = this;
  prototype.removedFiles.some(function(removedFile, index) {
    if (removedFile.checksum === file.checksum) {
      prototype.removedFiles.splice(index, 1);
      return true;
    }
  });
};

DragAndDrop.prototype.resetFileField = function() {
  const field = $(this.selector)
    .find(".drop-file-input")
    .first();
  field
    .wrap("<form>")
    .parent("form")
    .trigger("reset");
  field.val("");
  field.unwrap();
};

DragAndDrop.prototype._setBaseHTML = function(html) {
  const prototype = this;
  if ($(prototype.selector).find(".drop-file").length === 0) {
    $(prototype.selector)
      .find(".drop-files")
      .prepend(html);
  } else {
    $(prototype.selector)
      .find(".drop-file")
      .last()
      .after(html);
  }
};

// ************************ Utilities ***************** //
DragAndDrop.prototype.highlight = function() {
  $(this.selector).addClass("highlight");
};

DragAndDrop.prototype.unhighlight = function() {
  $(this.selector).removeClass("highlight");
};

DragAndDrop.prototype._prepareFormData = function(formData) {
  formData.append("upload_preset", "ujpu6gyk");
  const form = $(this.selector).parents("form");
  formData.append(
    "authenticity_token",
    $('meta[name="csrf-token"]').attr("content")
  );
  formData.append("utf8", form.find('input[name="utf8"]').val());

  // NOTE: all of this is to have compatibility with ie11
  // Unfortunately the existing polyfills dont work for our use case.
  // if formData is a real instance of FormData, just return.
  // else, iterate thru each property of formData object
  // and append it to a REAL FormData instance.
  // the enumerable properties of the formData object are the files
  // for each file, append it to a real FormData object.
  if (formData instanceof FormData) {
    return formData;
  }
  const _formData = new FormData();
  for (const [key, value] of Object.entries(formData)) {
    if (value instanceof Function) {
    } else if (value instanceof Array) {
      for (const file of value) {
        _formData.append(String(key), file);
      }
    } else {
      _formData.append(key, value);
    }
  }
  return _formData;
};

DragAndDrop.prototype.getUploadedFiles = function() {
  const prototype = this;
  const fileFieldName = $(prototype.selector)
    .find(".drop-file-input")
    .attr("name");
  return prototype.formData.getAll(fileFieldName);
};

export default DragAndDrop;
